<template>
  <div class="md:w-[55%]">
    <h1 class="mb-2 max-md:mb-4 md:mb-4">
      <WrGradientText
        :text="heading"
        append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
      />
    </h1>
    <p v-if="description" class="lg:text-xl tracking-[0.5px]">
      {{ description }}
    </p>
    <p class="lg:text-xl my-6">Excited! Talk to our experts.</p>
    <WrButton @click="handleModal">Get a Quote</WrButton>
  </div>
  <div :class="`w-full h-[400px] max-h-[400px]` " >
    <NuxtImg
      :src="src"
      :alt="alt"
     
      loading="eager"
     
      class="min-w-max object-contain w-full h-full"
      fetch-priority="high"
      format="webp"
    />
  </div>
</template>

<script setup>
defineProps({
  heading: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(["openModal"]);

function handleModal() {
  emit("openModal");
}
</script>

<style lang="scss" scoped></style>
